"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.moveButtons = void 0;

var moveButtons = function moveButtons(event, scrolling) {
  if (scrolling) {
    var currentX = scrolling.getCurrentTranslateX();
    var trackWidth = scrolling.getTrackWidth();
    var offsetLeft = event.target.offsetLeft;
    var buttonWidth = event.target.clientWidth; // доля видимой следующей кнопки (чтобы при прокручивании при выборе кнопке было видно и кусочек следующей кнопки)

    var nextButtonOffset = 0.6 * buttonWidth; // сдвиг вправо при нажатии крайней правой видимой кнопки
    // transform = *ширина видимой области* - *offset правого края кнопки* - *доля видимой справа следующей кнопки*

    var transform = trackWidth - (offsetLeft + buttonWidth) - nextButtonOffset;

    if (transform < currentX) {
      scrolling.transform(transform + 'px');
    } else {
      // сдвиг влево при нажатии крайней левой видимой кнопки
      // transform = *offset левого края кнопки* + *доля видимой слева следующей кнопки*
      transform = -offsetLeft + nextButtonOffset;

      if (offsetLeft - nextButtonOffset < Math.abs(currentX)) {
        scrolling.transform(transform + 'px');
      }
    }
  }
};

exports.moveButtons = moveButtons;